import sgFlag from './adminAssets/images/flags/sg.svg';
import idFlag from './adminAssets/images/flags/id.svg';

// DEFAULT CURRENCY
// IDR = Rp
// SGD = $

// ID
// export const DEFAULT_CURRENCY = "Rp";
// export const DEFAULT_COUNTRY_CODE = "ID";

// SG
export const DEFAULT_CURRENCY = '$';
export const DEFAULT_COUNTRY_CODE = 'SG';

export const countryOptions = [
    { code: 'SG', name: 'Singapore', url: 'https://sg.iwant-asia.com', image: sgFlag },
    { code: 'ID', name: 'Indonesia', url: 'https://id.iwant-asia.com', image: idFlag }
    // { code: 'CN', name: 'China', url: 'https://cn.iwant-asia.com' },
    // Add more countries as needed
];

export const formatCurrency = (value) => {
    let currencyconvertion = DEFAULT_CURRENCY === '$' ? 'SGD' : 'IDR';
    let localizationconvert = DEFAULT_CURRENCY === '$' ? 'en-SG' : 'en-US';

    return new Intl.NumberFormat(localizationconvert, {
        style: 'currency',
        currency: currencyconvertion,
        currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: currencyconvertion === 'IDR' ? 0 : 2, // No decimal for IDR, 2 decimals for SGD
    }).format(value);
};
